import type { IPatient } from '@principle-theorem/principle-core/interfaces';
import type { WithRef } from '@principle-theorem/shared';
import { toMoment } from '@principle-theorem/shared';

export class ScribePatientContext {
  /**
   * Assembles a prompt-context string from the patient record for use by both
   * live recording sessions and the upload tool. Owned here so the live and
   * upload paths cannot drift apart in what they tell the model about the
   * patient.
   */
  static build(patient: WithRef<IPatient>): string {
    const parts: string[] = [
      `Patient ID: ${patient.ref.id}`,
      `Name: ${patient.name}`,
    ];
    if (patient.dateOfBirth) {
      parts.push(`DOB: ${toMoment(patient.dateOfBirth).format('YYYY-MM-DD')}`);
    }
    if (patient.gender) {
      parts.push(`Gender: ${patient.gender}`);
    }
    return parts.join(', ');
  }
}
